<template>
  <section class="chosen-response">
    <ttn-response
      :item="item"
      :act="act"
      :ttns="ttns"
      @ttn="handleOpen"
      @new="handleReset"
    />
    <el-row type="flex" align="middle" justify="space-between">
      <h3 class="mt-10">Данные ТТН:</h3>
      <el-button type="text" class="td-u" @click="handleReset">
        Очистить форму
      </el-button>
    </el-row>
    <form-ttn
      :shortage="shortage"
      :load-date="item.load_date"
      :status-dates="getStatusDates()"
      :is-hardware="true"
      :ttn="ttn"
      :clear="clear"
      hardware-type="form"
      @next="handleNext"
      @clear="clear = false"
    />
    <modal-ttn
      :response="response"
      :shortage="shortage"
      :load-date="item.load_date"
      hardware-type="modal"
      @close="response = null"
      @next="handleChosen"
    />
    <img-orientation-modal
      :visible="checkImgsModal"
      :type="type"
      @save="handleSave"
      @close="checkImgsModal = false"
    />
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions } from 'vuex'
import FormTtn from '@/components/Forms/FormTTN'
import ImgOrientationModal from './ImgOrientationModal'
import ModalTtn from '@/components/Modals/ModalTTN'
import TtnResponse from './TtnResponse'

const TtnApi = RepositoryFactory.get('ttn')
const DocApi = RepositoryFactory.get('doc')

export default {
  name: 'ChosenResponse',
  components: { TtnResponse, FormTtn, ModalTtn, ImgOrientationModal },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      response: null,
      ttn: null,
      act: '',
      ttns: [],
      formData: null,
      clear: false,
      checkImgsModal: false,
    }
  },
  computed: {
    shortage() {
      const res = {}

      if (this.item) {
        const { allow_shortage_is_percents, allow_shortage } = this.item

        res.perc = allow_shortage_is_percents
        res.val = allow_shortage || 0
      }

      return res
    },
  },
  watch: {
    'item.response_id': {
      immediate: true,
      handler(id) {
        if (id) {
          this.getTTN(id)
          this.getAct(id)
        } else {
          this.ttns = []
          this.act = ''
        }
      },
    },
  },
  methods: {
    ...mapActions('hardware', ['saveHardwareTTN']),
    getTTN(id) {
      TtnApi.getList(id)
        .then(res => {
          this.ttns = res.data || []
          this.ttn = this.ttns[0] || null
        })
        .catch(err => this.errHandler(err))
    },
    getAct(id) {
      DocApi.getDocument('responses', id, 'works_act')
        .then(({ data }) => {
          const { number, document_create_date } = data[0] || {}

          if (number && document_create_date) {
            const day = this.dateToFormat(
              document_create_date,
              'shortDateWithoutYear',
            )

            this.act = `АКТ ${number || '-'} от ${day || '-'}`
          } else {
            this.act = ''
          }
        })
        .catch(err => this.errHandler(err))
    },
    getStatusDates() {
      const { date_loaded, date_unloaded } = this.item

      return { date_loaded, date_unloaded }
    },
    handleOpen() {
      const { response_id: id, state_numbers } = this.item

      this.response = { ...this.item, id, auto: { state_numbers } }
    },
    handleChosen(ttn = null) {
      this.ttn = ttn
      this.response = null
    },
    handleNext(formData) {
      this.formData = formData
      this.checkImgsModal = true
    },
    handleSave() {
      const { response_id } = this.item
      const date = this.dateToFormat(this.formData.date, 'defaultDate')
      const requestData = { ...this.formData, date, response_id }

      if (this.ttn?.id) {
        requestData.id = this.ttn.id
      }
      this.saveHardwareTTN(requestData)
    },
    handleReset() {
      this.ttn = null
      this.act = ''
      this.formData = null
      this.clear = true
    },
  },
}
</script>

<style lang="sass">
.chosen-response
  height: calc(100vh - 205px)
  overflow-y: auto
  padding: 0 10px
  .mt-10
    margin-top: 10px
</style>
